// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"ShortcutPinSection_wrapperMain__23imM","box":"ShortcutPinSection_box__1cjy4"};